var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004280",
    d: "M10.087 1.374a.75.75 0 0 1 .708-.064c1.611.69 2.59 1.667 3.163 2.785.561 1.095.7 2.263.752 3.275.015.296.024.608.032.899.005.187.01.364.016.522.017.436.045.794.108 1.088.063.293.149.47.243.581.083.098.213.193.47.247.302.063.459-.004.562-.08.132-.095.26-.273.369-.537.105-.256.205-.889.24-1.116a.75.75 0 0 1 1.336-.443c2.151 2.69 2.164 4.889 2.164 5.969a8.25 8.25 0 1 1-16.5 0c0-3.295 1.672-5.353 3.18-7.113C8.407 5.668 9.75 4.102 9.75 2a.75.75 0 0 1 .337-.626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    d: "M11.398 10.365a.75.75 0 0 1 .35.57c.076.891.372 1.88.922 2.49.262.292.575.492.959.575.387.083.91.06 1.608-.201a.75.75 0 0 1 1.013.702c0 2.713-1.738 5.25-4.25 5.25a4.06 4.06 0 0 1-3.027-1.311C8.194 17.592 7.75 16.402 7.75 15c0-.76.323-1.751.805-2.603.48-.846 1.216-1.73 2.177-2.097a.75.75 0 0 1 .666.064"
  })));
};
export default SvgFire;